export const LEAD_DRAWER_OPTIONS = {
  PROFILE: 'profile',
  ACTIVITY: 'activity',
  FILES: 'files',
  MESSAGES: 'chat',
  NOTES: 'notes',
} as const;

export type LeadDrawerOptions =
  typeof LEAD_DRAWER_OPTIONS[keyof typeof LEAD_DRAWER_OPTIONS];

/**
 * Query params used to deep-link into the leads board and auto-open a drawer,
 * e.g. from suggested actions. `open` opens the per-lead drawer on a specific
 * tab (handled in PortfolioLeads.page); `dealNotes` opens the deal-notes
 * drawer (handled in PortfolioSubnav).
 */
export const LEAD_BOARD_QUERY_PARAM = {
  LEAD_ID: 'leadId',
  OPEN: 'open',
  DEAL_NOTES: 'dealNotes',
} as const;

export const DEAL_NOTES_OPEN_VALUE = 'open';
